(function () {
  /* Galerij op een modelpagina: scrollen met de muis, het toetsenbord, de knoppen of door te vegen. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__swGal) return;
    var track = root.querySelector('[data-gal-track]');
    if (!track) return;
    root.__swGal = true;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gal-slide]'));
    var prev = root.querySelector('[data-gal-prev]');
    var next = root.querySelector('[data-gal-next]');
    var count = root.querySelector('[data-gal-count]');
    var ticking = false;

    function atEnd() {
      return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    function index() {
      if (atEnd()) return slides.length - 1;
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function update() {
      ticking = false;
      if (count) count.textContent = (index() + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = atEnd();
    }

    function go(dir) {
      var i = Math.max(0, Math.min(slides.length - 1, index() + dir));
      var pad = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
      track.scrollTo({ left: slides[i].offsetLeft - pad, behavior: reduce ? 'auto' : 'smooth' });
    }

    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    update();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sw-gallery]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
